import React from "react";
import { ArrowUpRight, Lock, Sparkles } from "lucide-react";

import { SHOPIFY_APP_STORE_URL } from "./constants";
import { CASH_IMPACT_LABEL, OPPS_COUNT } from "./aigoMetrics";

/**
 * StickyValueBar — persistent bar shown on desktop only, after the user scrolls
 * past the hero. Reinforces the diagnosis-free / execution-paid split.
 *
 * Mobile has the existing StickyMobileCta bottom bar (from Footer.jsx) — this
 * bar is desktop-only to avoid stacking. Dismissible.
 */
export const StickyValueBar = ({ visible, dismissed, onDismiss }) => {
  if (!visible || dismissed) return null;
  return (
    <div
      data-testid="sticky-value-bar"
      className="hidden md:flex fixed bottom-4 inset-x-0 z-[54] justify-center px-4 pointer-events-none"
      style={{ animation: "lift 320ms cubic-bezier(.2,.8,.2,1) both" }}
    >
      <div className="pointer-events-auto flex items-center gap-4 px-4 py-2.5 rounded-full bg-slate-900 text-white shadow-2xl shadow-slate-900/30 max-w-4xl">
        <span className="inline-flex items-center gap-2 text-sm font-semibold">
          <Sparkles className="w-4 h-4 text-emerald-400" />
          You have <span className="text-emerald-400 font-extrabold tabular-nums">{CASH_IMPACT_LABEL}</span> in approve-ready fixes waiting
        </span>
        <span className="hidden lg:inline text-slate-500">·</span>
        <span className="hidden lg:inline text-xs text-slate-400 tabular-nums">
          {OPPS_COUNT} opportunities queued
        </span>
        <a
          href={SHOPIFY_APP_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="sticky-value-bar-upgrade"
          className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full bg-emerald-500 hover:bg-emerald-600 text-white text-xs font-bold transition shadow-sm shadow-emerald-500/40"
        >
          <Lock className="w-3.5 h-3.5" />
          Unlock with Pro
          <ArrowUpRight className="w-3.5 h-3.5" />
        </a>
        <button
          data-testid="sticky-value-bar-dismiss"
          onClick={onDismiss}
          aria-label="Dismiss"
          className="shrink-0 w-7 h-7 rounded-full text-slate-400 hover:text-white hover:bg-slate-800 transition text-lg leading-none"
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default StickyValueBar;
